export interface Stat {
    id: number
    name: string
    short_name?: string
    value: string | number | null
    values?: StatusStat[]
}

export type StatusStat = Pick<Stat, 'value'> & { status_id: number };

export const enum StatType {
    COMPUTED_PERCENT = 'computed percent',
    EXPANDED_PERCENT = 'expanded percent',
    RAW_PERCENT = 'raw percent',
    RAW = 'raw',
    RAW_FLOAT = 'raw float'
}
